// @flow
/*
import {
	WebComponent,
} from 'fg-frontend';
*/

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'fg-frontend/plugins/jquery.triggerInViewport';

export default class TriggerInViewport extends WebComponent {
	didMount() {
		const {
			triggerInViewportTargetItem,
			triggerInViewportTriggerEventOn,
		} = this.props;

		$(this.element).triggerInViewport({
			'targetItem': triggerInViewportTargetItem || null,
			'triggerEventOn': triggerInViewportTriggerEventOn || null,
		});
	}
}



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/components/TriggerInViewport.js